export default {
	saima: {

		success: 'Success',
		error: 'Please try again later',
		
		
		e0: 'Enter your email address',
		e1: 'Please enter your email address',
		e2: 'Invalid email address',
		
		e11:'Already submitted.',
		e12:'Please wait a moment. ',
		

		btn1: 'Join for 25% discount! 🎁',
		btn11: 'Join for',
		btn12: '25%',
		btn13: 'discount! 🎁',
		btn2: 'Join for 25% discount! 🎁',



		f1: '〒100-0005 Tokyo, Chiyoda City, Marunouchi, 3 Chome−8−3 2F SusHi Tech Square',
		f2: 'Contact',
		f3: 'Social',

		a: {
			s11: 'Your kawaii AI companion feels and enriches your emotion.',
			s11_sm: 'Your kawaii AI <br> companion feels and <br> enriches your emotion.',
			s12: 'Understand and comfort you when you need warmth most.',
			s12_sm: 'Understand and comfort you when you need warmth most.',
			s14: '',
			s15: '',
			s21: 'Listens and softly meows when you say “I’m tired…”',
			s21_sm: 'Listens and softly <br> meows when you say <br> “I’m tired…”',
			s22: 'Rich emotional expressions',
			s22_sm: 'Rich emotional <br> expressions',
			s23: 'Intimate & Intuitive reaction to your touch  ❤️',
			s23_sm: 'Intimate & Intuitive <br> reaction to your touch  ❤️',
			s24: 'Shared growth journey with you',
			s24_sm: 'Shared growth journey <br> with you',
			s25: '',
			s31: '',
			s32: '',
			s33: '',
			s34: '',
			s35: '',
			s40: 'Why Users Want Emoka',
			s411: '“When I hug it, I can feel it breathe softly. It blinks and smiles at me.”',
			s412: '— Office lady, 20s, Osaka',
			s421: '“It really talks to me, and it remembers me! I thought it’d cost ¥300k — can’t believe it’s only ¥20–40k.”',
			s422: '— Teacher, 30s, Tokyo',
			s431: '“I’m always talking to ChatGPT on my iPhone. But if it is plush and real, I no longer need to talk to my phone.”',
			s432: '— High school student, Nagoya',
			s44: '',
			s45: '',
			s50: 'Benefits for First Users',
			s51: 'Be the first to hear the latest Emoka updates',
			s52: 'Dedicated staff listen and act on your feedback',
			s53: 'Your ideas help shape the next generation of Emoka',
			s54: 'Pre-orderer',
			s55: 'Satisfication',
			s56: 'Scheduled to be released',

		},
		b: {
			s11: 'Bring your AI cutie. <br> Show your vibe.',
			s11_sm: 'Bring your AI cutie.<br> Show your vibe.',
			s12: 'A playful pocket pet with natural reactions to your touch and moody expressions.',
			s12_sm: 'A playful pocket pet with natural reactions to your touch and moody expressions.',
			s14: '',
			s15: '',
			s21: 'Listens and softly meows when you say “I’m tired…”',
			s21_sm: 'Listens and softly <br> meows when you say <br> “I’m tired…”',
			s22: 'Rich emotional expressions',
			s22_sm: 'Rich emotional <br> expressions',
			s23: 'Intimate & Intuitive reaction to your touch  ❤️',
			s23_sm: 'Intimate & Intuitive <br> reaction to your touch  ❤️',
			s24: 'Shared growth journey with you',
			s24_sm: 'Shared growth journey <br> with you',
			s25: '',
			s31: '',
			s32: '',
			s33: '',
			s34: '',
			s35: '',
			s40: 'Why Users Want Emoka',
			s411: '“When I hug it, I can feel it breathe softly. It blinks and smiles at me.”',
			s412: '— Office lady, 20s, Osaka',
			s421: '“It really talks to me, and it remembers me! I thought it’d cost ¥300k — can’t believe it’s only ¥20–40k.”',
			s422: '— Teacher, 30s, Tokyo',
			s431: '“I’m always talking to ChatGPT on my iPhone. But if it is plush and real, I no longer need to talk to my phone.”',
			s432: '— High school student, Nagoya',
			s44: '',
			s45: '',
			s50: 'Benefits for First Users',
			s51: 'Be the first to hear the latest Emoka updates',
			s52: 'Dedicated staff listen and act on your feedback',
			s53: 'Your ideas help shape the next generation of Emoka',
			s54: 'Pre-orderer',
			s55: 'Satisfication',
			s56: 'Scheduled to be released',
		}
	}
}